"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "@/models/tags.model";
import i18n from "@/lang";
export let SelectOptionsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.timezones = [];
    this.regions = [];
    this.languages = [];
    this.countries = [];
    this.resolution = [];
    this.version = "";
  }
};
SelectOptionsModel.model = "payment.virtualdesktop.options.create";
SelectOptionsModel = __decorateClass([
  Annotation.ModelMeta
], SelectOptionsModel);
export let TimezoneModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
  }
};
TimezoneModel.model = "payment.virtualdesktop.options.create.timezone";
TimezoneModel = __decorateClass([
  Annotation.ModelMeta
], TimezoneModel);
export let RegionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.default_selection = new DefaultRegionModel();
    this.show_auto_renew = false;
    this.marks = new TagsModel();
    this.show_auto_timezone = false;
    this.risk_level = 0;
    this.sortValue = 0;
    this.name = "";
    this.parent_category = new ParentCategoryModel();
    this.limit = new LimitModel();
    this.top_category = new TopCategoryModel();
    this.comment = "";
    this.id = "";
    this.stock = new StockModel();
    this.goods_spec = [];
    this.ebusinesses = [];
    //增加远程group
    this.region_type = new RemoteRegionModel();
    this.region_model = null;
  }
  disabled() {
    if (this.stock.goods_stock_left === 0) {
      return true;
    }
    return false;
  }
  stock_tag() {
    if (this.stock.goods_stock_left <= -1) {
      return null;
    }
    if (this.stock.goods_stock_left === 0) {
      return i18n.t("selectoptions.goods.left");
    }
    return this.stock.goods_stock_left;
  }
};
RegionModel.model = "payment.virtualdesktop.options.create.region";
RegionModel = __decorateClass([
  Annotation.ModelMeta
], RegionModel);
export let GoodSpecModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.discount_tag = "";
    this.price_description = "";
    this.id = "";
    this.spec_name = "";
  }
};
GoodSpecModel.model = "payment.virtualdesktop.goods.Spec";
GoodSpecModel = __decorateClass([
  Annotation.ModelMeta
], GoodSpecModel);
export let DefaultRegionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.timezone_id = "";
    this.language_id = "";
    this.country_id = "";
  }
};
DefaultRegionModel.model = "payment.virtualdesktop.options.create.region_default_selection";
DefaultRegionModel = __decorateClass([
  Annotation.ModelMeta
], DefaultRegionModel);
export let ParentCategoryModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
    this.marks = new TagsModel();
    this.remotes = [];
  }
};
ParentCategoryModel.model = "payment.virtualdesktop.options.create.parent_region";
ParentCategoryModel = __decorateClass([
  Annotation.ModelMeta
], ParentCategoryModel);
export let LimitModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.min = 0;
    this.max = 0;
  }
};
LimitModel.model = "payment.virtualdesktop.options.create.buy_limit";
LimitModel = __decorateClass([
  Annotation.ModelMeta
], LimitModel);
export let TopCategoryModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.is_new = false;
    this.is_recommend = false;
    this.name = "";
    this.id = "";
    // tips?:object = {
    //     "title":"",
    //     "message":""
    // };
    this.tips = null;
    this.region_tags = new RegionTags();
    this.marks = new TagsModel();
    this.groups = [];
  }
};
TopCategoryModel.model = "payment.virtualdesktop.options.create.top_region";
TopCategoryModel = __decorateClass([
  Annotation.ModelMeta
], TopCategoryModel);
export let RegionTags = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.property = null;
  }
};
RegionTags.model = "tag.item";
RegionTags = __decorateClass([
  Annotation.ModelMeta
], RegionTags);
export let StockModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.goods_stock_left = 0;
  }
};
StockModel.model = "payment.virtualdesktop.options.create.goods_stock";
StockModel = __decorateClass([
  Annotation.ModelMeta
], StockModel);
export let EbusinessPlatformModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.sort = 0;
    this.caption = "";
    this.support = true;
  }
};
EbusinessPlatformModel.model = "payment.virtualdesktop.options.create.support_ebusiness_platform";
EbusinessPlatformModel = __decorateClass([
  Annotation.ModelMeta
], EbusinessPlatformModel);
export let LanguageModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
  }
};
LanguageModel.model = "payment.virtualdesktop.options.create.language";
LanguageModel = __decorateClass([
  Annotation.ModelMeta
], LanguageModel);
export let CountriesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
    this.default_selection = new CountriesDefaultModel();
    this.operating_systems = [];
    this.browsers = [];
    this.region_default_selection = [];
  }
};
CountriesModel.model = "payment.virtualdesktop.options.create.country";
CountriesModel = __decorateClass([
  Annotation.ModelMeta
], CountriesModel);
export let RegionDefaultModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.timezone_id = "";
    this.language_id = "";
    this.region_guid = "";
  }
};
RegionDefaultModel.model = "payment.virtualdesktop.options.create.country_region_default_selection";
RegionDefaultModel = __decorateClass([
  Annotation.ModelMeta
], RegionDefaultModel);
export let CountriesDefaultModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.timezone_id = "";
    this.language_id = "";
  }
};
CountriesDefaultModel.model = "payment.virtualdesktop.options.create.country_default_selection";
CountriesDefaultModel = __decorateClass([
  Annotation.ModelMeta
], CountriesDefaultModel);
export let CountryOsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
    this.sort = 0;
  }
};
CountryOsModel.model = "payment.virtualdesktop.options.create.country_support_os";
CountryOsModel = __decorateClass([
  Annotation.ModelMeta
], CountryOsModel);
export let BrowsersModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
  }
};
BrowsersModel.model = "payment.virtualdesktop.options.create.country_support_browser";
BrowsersModel = __decorateClass([
  Annotation.ModelMeta
], BrowsersModel);
export let ResolutionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
  }
};
ResolutionModel.model = "payment.virtualdesktop.options.create.resolution";
ResolutionModel = __decorateClass([
  Annotation.ModelMeta
], ResolutionModel);
export let RemoteRegionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.text = "";
    this.key = "";
    this.types = null;
    this.regions = [];
    this.marks = new TagsModel();
  }
};
RemoteRegionModel.model = "payment.virtualdesktop.options.create.region_type";
RemoteRegionModel = __decorateClass([
  Annotation.ModelMeta
], RemoteRegionModel);
export let TypeRegionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.text = "";
    this.regions = [];
    this.marks = new TagsModel();
  }
};
TypeRegionModel.model = "payment.virtualdesktop.options.create.region_model";
TypeRegionModel = __decorateClass([
  Annotation.ModelMeta
], TypeRegionModel);
